import React from 'react';
import { onChange, setOptions, validateForm } from './../../utils';
import { getEncashmentStatus } from '../../actions/MasterAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            detailId: props.detailId,
            statusId: { name: 'statusId', value: '', options: [], error: '', isRequired: true },
            comment: { name: 'comment', value: '', error: '', isRequired: false },
        }
    }

    componentDidMount() {
        getEncashmentStatus().then((res: any) => {
            setOptions(this, this.state.statusId.name, res.result);
        })
    }

    render() {
        const { statusId, comment } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Status <small>*</small></label>
                                        <select
                                            className={statusId.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            name={statusId.name}
                                            value={statusId.value}
                                            onChange={this.onChange}
                                        >
                                            <option>Select a status</option>
                                            {
                                                statusId.options.map(function (item: any, index: number) {
                                                    return (
                                                        <option key={index} value={item.id}>{item.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Comment <sup>*</sup></label>
                                        <textarea
                                            rows={5}
                                            className={comment.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder="Enter your message here"
                                            name={comment.name}
                                            value={comment.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.toggleModal} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                                </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const st = this.state;
            const model = {
                detailId: st.detailId,
                statusId: st.statusId.value,
                comment: st.comment.value,
            };

            this.props.onSubmit(model);
        }
    }
}

export default ComponentName;